import Breadcrumb from './../../components/BreadCrumb';
import ServiceComponent from './../../components/ServiceComponent';
import HeadingDetailsSection from './../../sections/HeadingDetailsSection';
import { faFileSignature, faUserCheck, faUserGear } from '@fortawesome/free-solid-svg-icons';
import image from './../../assets/pexels/hr.jpg';

function HRLegalSupportScreen() {
  return (
    <>
        <HeadingDetailsSection heading='HR Legal Support'>
          <Breadcrumb parent="Services" screen='HR Legal Support'/>
        </HeadingDetailsSection>
        <ServiceComponent
          heading="HR Legal Support"
          description="Ensure your HR practices are legally sound with PocketLPO’s HR Legal Support. We assist businesses in managing employment agreements, policies, and compliance requirements."
          services={[
            "Drafting employment agreements and handbooks.",
            "Policy development and compliance checks.",
            "Advice on benefits documentation and HR regulations."
          ]}
          benefits={[
            { title: "Compliant Practices", description: "Avoid legal issues with well-drafted documents.", icon: faFileSignature },
            { title: "Tailored Support", description: "Services customized to your workforce needs.", icon: faUserCheck },
            { title: "Expert Guidance", description: "Navigate complex HR regulations confidently.", icon: faUserGear }
          ]}
          image={image}
        />
    </>
  );
}

export default HRLegalSupportScreen;
